import { GlIcon } from '@gitlab/ui';
export default {
    name: 'DetailsRow',
    components: {
        GlIcon
    },
    props: {
        icon: {
            type: String,
            required: false,
            default: null
        },
        padding: {
            type: String,
            default: 'gl-py-2',
            required: false
        },
        dashed: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        borderClass () {
            return this.dashed ? 'gl-border-b-solid gl-border-default gl-border-b-1' : '';
        }
    }
};
